


import React, { useState } from "react"
import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { useEffect } from "react"
import moment from "moment"
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions"
import { getUserData, setSelectUserData } from "../../../../features/user/userSlice"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import Button from "../../../shared/button/Btn"
import { showModal, showNestedModal } from "../../../../features/modal/modalSlice"
import { getBelgeData, getSingleShipmentLoadItem, setCompleteShipmentIds, setShipmentActionData, setShipmentContainerAndSealData, setShipmentData } from "../../../../features/loadList/loadListSlice"
import { setIsActiveSide, setTopPagesMapShipmentItemCurrentLocationData } from "../../../../features/topPagesMap/topPagesMapSlice"
import { getShipmentDetailsForManage } from "../../../../features/shipmentOperation/shipmentOperationSlice"
import ShipmentTrackingDetails, { findDetailedRoutePoint, RoutePointOperationInfo, unwrapTrackingCollection } from "../../../shipmentOperation/ShipmentTrackingDetails"
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue"
import { wideShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles"
import ShipmentSelectionCheckbox from "../../shared/ShipmentSelectionCheckbox"


const Container = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    border-radius: 10px;
    color: ${({theme}) => theme.mainTextColor};
    cursor: pointer;
    position: relative;
            .absolute-id{
            position: absolute;
            bottom: 0;
            left: 0;
            border: 1px solid var(--color-main);
            border-radius: 4px;
            border-bottom-left-radius: 10px;
            padding: 3px;
            font-size: 14px;
            width: 70px;
            text-align: center;
            font-weight: var(--font-weight-lg);
            background-color: var(--color-main);
            color:#fff;
        }
    .content-side{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    width: calc(100% - 450px);
    margin: 20px;
    min-height: 300px;

    .column-container{
      width: calc(33% - 10px);
      display: flex;
      flex-direction: column;
      gap: 30px;

      .column-item{
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 120px;

        .column-item-title{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-xl);
          margin-bottom: 10px;
          color: var(--color-main);
          border-bottom: 1px solid var(--color-main);
        }

        .content-item{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          padding-bottom: 8px;
        }

        .text-sm{
          font-size: 12px;
        }

        .outlined{
            border: 1px solid var(--color-main);
            border-radius: 5px;
            width: 110px;
            text-align: center;
            padding: 4px;
            margin-bottom: 5px;
            font-weight: var(--font-weight-lg);
        }

        .driver{
            color: var(--color-main);
            font-weight: var(--font-weight-lg);
            text-decoration: underline;
        }


        .route-list {
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;

          .content-item {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            padding-bottom: 8px;
          }

          .seperator {
            border-top: 1px solid ${({ theme }) => theme.mainTextColor};
          }

          .bold {
            font-weight: var(--font-weight-lg);
            text-decoration: underline;
          }
        }


      }


    }
    
  }

    .map-side{
        width: 450px;
        margin: 20px;
        min-height: 300px;
        display: flex;
        flex-direction: column;

        .map-container{
            width: 100%;
            height: 470px;
            border-radius: 10px;
        }

        .btn-container{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            margin-top: 10px;
            button{
                margin-right: 5px;
                padding: 10px;
            }
        }
    }

    .driver{
        color: var(--color-main);
        text-decoration: underline;
    }

    .text-sm{
        font-size: 12px;
        font-weight: var(--font-weight-md);
    }
    .btn-outlined{
        border: 1px solid var(--color-main);
        font-weight: var(--font-weight-lg);
        font-size: 12px;
        padding: 4px;
        border-radius: 6px;
        width: max-content;
        height: max-content;
    }


    @media (max-width: 1500px){
      .map-side {
        width: 350px;
        min-height: 200px;
        .map-container {
          height: 400px;
        }

        .btn-container {
          gap: 10px;
          button{
            height: 50px;
          }
        }
      }
    }

    @media (max-width: 1500px){
      .content-side{
        width: 100%;
      }
    }

    ${wideShipmentCardStyles}
`

const ItemContainerWide = ({item: sourceItem, activeItemId, setActiveItemId, forwardRef, handleClick, isSelected, onSelectionChange, onShowMap}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const dispatch = useDispatch()
    const {userData} = useSelector((state)=>state.user)
    const [trSaat, setTrSaat] = useState("");
    const {topPagesMapAllShipmentCurrentLocationList = []} = useSelector(state => state.topPagesMap)
    const singleShipmentLoadItem = useSelector(state => state.loadList.singleShipmentLoadItem)
    const detailedRoutePoints = item.id === activeItemId && singleShipmentLoadItem?.id === item.id
      ? unwrapTrackingCollection(singleShipmentLoadItem.routePoints)
      : []


    useEffect(()=> {
        if(item.driverPhoneNumber){
          dispatch(getUserData(item.driverPhoneNumber))
        }
    },[])

    useEffect(() => {
        if (userData && userData?.konumSonGorulme) {
        const splitTime = userData?.konumSonGorulme.split(" ");
        const newDate = splitTime[0];
        const newTime = splitTime[1];
        
        const [gun, ay, yil] = newDate.split("/");
        const formattedDate = `${yil}-${ay}-${gun}`;
        
        let trTarih = new Date(`${formattedDate}T${newTime}Z`);
        
        let birlesikTarih = `${trTarih.toLocaleDateString('tr-TR')} ${trTarih.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`;
        
        setTrSaat(birlesikTarih);
        }
  }, [userData]);

  const handleBelgeDataClick = () => {

    const list = item.routePoints.$values.map((item) => {
        return {
            routeType: item.loadOrUnload,
            stateOfRoutePoint: item.stateOfRoutePoint,
            documentOfRoutePoint: item.documentOfRoutePoint,
            order: item.order,
            comment: item.description,
            location: item.location

        }
  }).filter(item =>  item.stateOfRoutePoint !== 0)

    dispatch(getBelgeData(list))
    dispatch(showModal("shipmentIrsaliye"))
}

const handleMapFocus = () => {

    onShowMap?.()

    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(getSingleShipmentLoadItem(item.id));
    dispatch(setIsActiveSide(true));
    dispatch(setTopPagesMapShipmentItemCurrentLocationData(item.id))
}

  return (
    <Container activeItem={item.id === activeItemId} onClick={() => window.getSelection().toString().length < 1 && setActiveItemId(item.id === activeItemId ? null : item.id)}>
            <ShipmentSelectionCheckbox checked={isSelected} onChange={onSelectionChange} shipmentId={item.id} />
            <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />

 <div className="content-side">

<div className="column-container">
    <div className="column-item">
        <h3 className="column-item-title">Ödeme</h3>
        <div className="content-item">{formatConverter(item.freight, 0)} {item.paymentUnit === 0 ? "TL/Komple" : "TL/Ton"} <span className="text-sm">(Hedef Fiyatınız {item.freightVisibility ? "Yayınlanıyor" : "Yayınlanmıyor"})</span></div>
        <div className="content-item">{item.waitinLoad.paymentType}</div>
        {
            (item.waitinLoad.fuelPaymentId > 0 && item.waitinLoad.fuelPayment > 0) &&
            <div className="content-item">Yakıt {item.waitinLoad.fuelPaymentId === 1 && "%"} {item.waitinLoad.fuelPayment} {item.waitinLoad.fuelPaymentId === 2 && "TL"}</div>
        }
        {
            (item.commissionPayment > 0 && item.commissionPaymentId > 0) &&
            <div className="content-item">Komisyon {item.commissionPaymentId === 1 && "%"} {item.commissionPayment} {item.commissionPaymentId === 2 && "TL"}</div>
        }
    </div>

    <div className="column-item">
      <h3 className="column-item-title">Yükleme</h3>
      {item.routePoints.$values
        .filter((item) => item.loadOrUnload === 0)
        .map((routeItem, i) => (
          <div className="route-list">
            <div className="content-item">
              {formatShipmentDate(routeItem.loadDate, value => moment(value).format("DD.MM.YYYY"))}{" "}
              {routeItem.loadTime}
            </div>
            <div className="content-item bold">
              {i + 1}. {routeItem.displayName}
            </div>
            <div className="content-item">{routeItem.location}</div>
            <div className="content-item">{routeItem.address}</div>
            <div className="content-item">
              {routeItem.loadMethods.$values.length > 0 ? routeItem.loadMethods.$values.map((item) => `${item.name} `) : "---"}
            </div>
            <div className="content-item">
              {routeItem.routePointPersonName}
            </div>
            <div className="content-item">
              {routeItem.routePointPersonPhoneNumber}
            </div>
            {routeItem.stateOfRoutePoint === 0 &&
                <div className="content-item">Yüklemeye Başlanmadı</div>
            }
            {routeItem.stateOfRoutePoint === 1 &&
                <div className="content-item">Yüklemeye Başlandı</div>
            }
            {routeItem.stateOfRoutePoint === 2 &&
                <div className="content-item">Yükleme Tamamlandı</div>
            }
            <RoutePointOperationInfo routePoint={findDetailedRoutePoint(routeItem, detailedRoutePoints)} />
            {item.routePoints.$values.filter(
              (item) => item.loadOrUnload === 0
            )?.length !==
              i + 1 && <div className="seperator" />}
          </div>
        ))}
      </div>

</div>


<div className="column-container">
    <div className="column-item">
        <h3 className="column-item-title">Yük</h3>
        <div className="content-item">{item.waitinLoad?.senderName}</div>
        <div className="content-item">{item.waitinLoad.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}</div>
        {
            item.waitinLoad.loadUnit === "BASAR TONAJ" ? 
            <div className="content-item">Basar Tonaj {((item.waitinLoad.loadBulk > 0) &&` - ${item.waitinLoad.loadBulk}`)}</div>
            :
            <div className="content-item">{item.waitinLoad.loadQuantity} {item.waitinLoad.loadUnit} {(item.waitinLoad.loadBulk > 0) &&` - ${item.waitinLoad.loadBulk}`}</div>
        }
        <div className="content-item">{item.waitinLoad.loadType}</div>
         <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
         <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
         <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />
        <div className="content-item">{item.waitinLoad.loadDescription}</div>
    </div>

    <div className="column-item">
      <div className="column-item-title">Boşaltma</div>
        {item.routePoints.$values
          .filter((item) => item.loadOrUnload === 1)
          .map((routeItem, i) => (
            <div className="route-list">
              <div className="content-item">
                {formatShipmentDate(routeItem.loadDate, value => moment(value).format("DD.MM.YYYY"))}{" "}
                {routeItem.loadTime}
              </div>
              <div className="content-item bold">{i + 1}. {routeItem.displayName}</div>
              <div className="content-item">{routeItem.location}</div>
              <div className="content-item">{routeItem.address}</div>
              <div className="content-item">{routeItem.loadMethods.$values.length > 0 ? routeItem.loadMethods.$values.map((item) => `${item.name} `) : "---"}</div>
              <div className="content-item">{routeItem.routePointPersonName}</div>
              <div className="content-item">{routeItem.routePointPersonPhoneNumber}</div>
              {routeItem.stateOfRoutePoint === 0 &&
                <div className="content-item">Boşaltmaya Başlanmadı</div>
              }
              {routeItem.stateOfRoutePoint === 1 &&
                  <div className="content-item">Boşaltmaya Başlandı</div>
              }
              {routeItem.stateOfRoutePoint === 2 &&
                  <div className="content-item">Boşaltma Tamamlandı</div>
              }
              <RoutePointOperationInfo routePoint={findDetailedRoutePoint(routeItem, detailedRoutePoints)} />
              {item.routePoints.$values.filter(
                (item) => item.loadOrUnload === 1
              )?.length !==
                i + 1 && <div className="seperator" />}
            </div>
          ))}
      </div>
    
</div>


<div className="column-container">
    <div className="column-item">
        <h3 className="column-item-title">Araç</h3>
        <div className="content-item">{item.waitinLoad.truckQuantity < 1 ?  1 : item.waitinLoad.truckQuantity} Adet</div>
        <div className="content-item">{item.waitinLoad.truckName} {item.waitinLoad.trailerName}</div>
        <div className="content-item">{item?.truckPlateNumber}</div>
        <div className="content-item">{item?.trailerPlateNumber}</div>
        {
            item.waitinLoad.groundType && 
            <div className="content-item">{item.waitinLoad.groundType}</div>
        }
    </div>

    <div className="column-item" style={{minHeight: "auto"}}>
        <h3 className="column-item-title">Sürücü</h3>
        <div onClick={() => {dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item?.driverPhoneNumber)) }} className="content-item driver">{item?.driverName}</div>
        <div className="content-item">Son konum bilgisi: {trSaat}</div>
    </div>

    <div className="column-item" style={{minHeight: "auto"}}>
        <h3 className="column-item-title">Belgeler</h3>
        <div className="content-item outlined" onClick={(e)=> {e.stopPropagation(); handleBelgeDataClick(item)}}>Sevk İrsaliyesi</div>
        <div className="content-item outlined" onClick={(e)=> {e.stopPropagation(); dispatch(setShipmentData(item)); dispatch(showModal("showMektupShipment"))}}>Taşıma Senedi</div>
    </div>

    <div className="column-item" style={{minHeight: "auto"}}>
        <h3 className="column-item-title">Diğer Bilgiler</h3>
        <div className="content-item">{item.companyName}</div>
        <div className="content-item">{yayinlamaSecenekleriOptions?.find(pItem => pItem?.id === item?.waitinLoad?.publishingTypeId)?.text ?? "---"}</div>
        <div className="content-item">{item.distance} Km</div>
    </div>

</div>

{item.id === activeItemId && <ShipmentTrackingDetails className="tracking-history" shipmentId={item.id} />}
</div>
      <div className="wide-actions" onClick={(e) => e.stopPropagation()}>
                <Button bgColor={"#E85446"} color={"#fff"} width={"160px"} handleClick={() => {dispatch(showModal("shipmentOperation")); dispatch(getShipmentDetailsForManage(item))}}>Sevkiyatı Yönet</Button>
                <Button bgColor={"#E85446"} color={"#fff"} width={"170px"} handleClick={() => {dispatch(setCompleteShipmentIds([item.id])); dispatch(showModal("completeShipmentsPermission"))}}>Sevkiyatı Tamamla</Button>
                <Button bgColor={"#E85446"} color={"#fff"} width={"230px"} handleClick={() => {
                  dispatch(setShipmentContainerAndSealData({
                    shipmentId: item.id,
                    containerNumber: sourceItem?.containerNumber ?? "",
                    sealNumber: sourceItem?.sealNumber ?? ""
                  }))
                  dispatch(showModal("updateShipmentContainerAndSealNumbers"))
                }}>Konteyner-Mühür No Güncelle</Button>
                <Button bgColor={"#E85446"} color={"#fff"} width={"190px"} handleClick={() => { dispatch(setShipmentActionData(sourceItem)); dispatch(showModal("updateShipmentVehicle")); }}>Sürücü-Araç Değiştir</Button>
                <Button bgColor={"transparent"} color={"#E85446"} borderColor={"#E85446"} width={"130px"} handleClick={() => { dispatch(setShipmentActionData(sourceItem)); dispatch(showModal("deleteShipmentPermission")); }}>Sevkiyatı Sil</Button>
                {
                  topPagesMapAllShipmentCurrentLocationList.map(item => item.shipmentId).includes(item.id) && 
                  <Button bgColor={"#E85446"} color={"#fff"} width={"220px"} handleClick={handleMapFocus}>Sürücü Konumunu Görüntüle</Button>
                }
      </div>
</Container>
  )
}

export default ItemContainerWide
